import LadderDistance from '../components/LadderDistance.jsx';
import { Country } from '../models/Country';
import { State } from '../models/State';
import { Locality } from '../models/Locality';
import { CacheableDataObject } from 'models/CacheableDataObject.jsx';

export class Location extends CacheableDataObject {
	beforeConstruct() {
		this.distanceFromLocations = new Map();
		this.country = null;
		this.state = null;
		this.locality = null;
		this.latitude = null;
		this.longitude = null;
		this.inferred = false;
		this.continent = null;
	}

	// Guessed by the server from the player's IP address rather than pinned by
	// them. It has rough coordinates and names only its continent; matchmaking
	// measures distance with it, but it never goes on a map.
	get isInferred() {
		return this.inferred;
	}

	// Enough to keep as a player's location: named places, or a guess with
	// coordinates to measure distance from.
	isKnown() {
		return this.isComplete() || (this.isInferred && this.hasCoordinates());
	}

	// The continent of a guessed location, which profiles show as an estimate.
	estimatedContinent() {
		if(!this.isInferred || !this.continent) {
			return null;
		}
		return this.continent.name;
	}

	canShowOnMap() {
		return this.hasCoordinates() && !this.isInferred;
	}

	get distanceFromUser() {
		if(myUser.location) {
			return myUser.location.getDistanceFromLocation(this);
		}
		return new Distance(0);
	}

	isComplete() {
		if(this.country === null && this.state === null && this.locality === null) {
			return false;
		}
		return true;
	}

	isSame(otherLocation) {
		if(this.state !== otherLocation.state) {
			return false;
		}
		if(this.country !== otherLocation.country) {
			return false;
		}
		if(this.locality !== otherLocation.locality) {
			return false;
		}
		if(this.hasCoordinates() !== otherLocation.hasCoordinates()) {
			return false;
		}
		if(this.latitude !== otherLocation.latitude) {
			return false;
		}
		if(this.longitude !== otherLocation.longitude) {
			return false;
		}
		return true;
	}

	hasCoordinates() {
		return this.latitude !== null;
	}

	getLatitude() {
		return this.latitude;
	}

	getLongitude() {
		return this.longitude;
	}

	getDistanceFromLocation(location) {
		if(this.distanceFromLocations.has(location)) {
			return this.distanceFromLocations.get(location);
		}
		const distance = LadderDistance.getDistanceFromLocations(location, this);
		this.distanceFromLocations.set(location, distance);
		return distance;
	}

	relativeLocation() {
		if(this.isInferred) {
			return null;
		}
		var country;
		var state;
		var locality;
		let localLocation = {};
		const location = this;
		if(myUser.location) {
			localLocation = myUser.location;
		}
		if(location.country && localLocation.country && location.country.id !== localLocation.country.id) {
			country = location.country.name;
		}
		if(location.state) {
			state = location.state.name;
		}
		if(location.locality) {
			locality = location.locality.name;
		}
		if(locality && state && country) {
			return locality + ', ' + state + ' (' + country + ')';
		}
		if(country && locality) {

		}
		if(state && locality) {
			return locality + ', ' + state;
		}
		if(state && country) {
			return state + ', ' + country;
		}
		if(state) {
			return state;
		}
		if(country) {
			return country;
		}
		if(location.country) {
			return location.country.name;
		}
		return 'Not Set';
	}

}

Location.prototype.dataLocationParsers = {
	inferred: (location, data) => {
		location.inferred = data.inferred === true;
	},
	continent: (location, data) => {
		location.continent = data.continent ? { id: data.continent.id, name: data.continent.name } : null;
	},
	country: (location, data) => {
		if(!data.country) {
			return;
		}
		location.country = Country.retrieve(data.country);
	},
	locality: (location, data) => {
		if(!data.locality) {
			return;
		}
		location.locality = Locality.retrieve(data.locality, data.locality.id + data.locality.name);
	},
	state: (location, data) => {
		if(!data.state) {
			return;
		}
		location.state = State.retrieve(data.state);
	},
	coordinates: (location, data) => {
		if(Array.isArray(data.coordinates)) {
			location.latitude = Number.parseFloat(data.coordinates[1]);
			location.longitude = Number.parseFloat(data.coordinates[0]);
		}
		else if(data.coordinates.hasOwnProperty('longitude') && data.coordinates.hasOwnProperty('latitude')) {
			location.latitude = Number.parseFloat(data.coordinates.latitude);
			location.longitude = Number.parseFloat(data.coordinates.longitude);
		}
		if(Number.isNaN(location.latitude)) {
			location.latitude = null;
		}
		if(Number.isNaN(location.longitude)) {
			location.longitude = null;
		}
	},
};

window.Location = Location;